import { render } from "./LedContentField.vue?vue&type=template&id=2834a97f&scoped=true"
import script from "./LedContentField.vue?vue&type=script&lang=js"
export * from "./LedContentField.vue?vue&type=script&lang=js"

import "./LedContentField.vue?vue&type=style&index=0&id=2834a97f&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2834a97f"]])

export default __exports__